import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { shopModule } from "./shop-module.js";

Vue.use(Vuex);

const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD
};

export default new Vuex.Store({
  modules: {
    shop: shopModule
  },
  state: {
    site: [],
    home: [],
    collections: [],
    textiles: [],
    categories: [],
    items: [],
    about: [],
    conditions: [],
    policy: [],
    masque: [],
    headmasque: [],
    stockist: [],
    sizeguide: [],
    success: [],
    retrait: []
  },
  getters: {
    getItemByUID: state => (uid, collection = state.items) => {
      let i = collection.length;
      while (i--) {
        if (collection[i].uid === uid) {
          return collection[i];
        }
      }
    },
    getCollectionByUID: state => (parent, uid) => {
      let collection = state[parent];
      let i = collection.length;
      while (i--) {
        if (collection[i].uid === uid) {
          return collection[i];
        }
      }
    },
  },
  actions: {
    async loadSite({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "site",
            select: {
              title: true,
              url: true,
              instagram: true,
              facebook: true,
              nav: {
                  query: "site.children.listed.not('home')",
                  select: {
                        uid: true,
                        title: true
                  }
              }
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_SITE", response.data.result);
        });
    },
    async loadHome({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('home').contenu.toStructure",
            select: {
              type: "structureItem.type",
              pagelink: {
                query: "structureItem.pagelink.toPage",
                select: {
                  title: "page.title",
                  parent: "page.parent.uid",
                  uid: "page.uid"
                }
              },
              width: "structureItem.width",
              marquee: "structureItem.marquee",
              text: "structureItem.text.kirbytext",
              image: {
                query: "structureItem.image.toFile",
                select: {
                  url: "file.resize(800).url",
                  thumb: "file.resize(100).url"
                }
              },
              video: {
                query: "structureItem.video.toFile",
                select: {
                  url: "file.url"
                }
              }
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_HOME", response.data.result.data);
        });
    },
    async loadCollections({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: `page('${payload}').children.listed`,
            select: {
              title: "page.title",
              uid: "page.uid",
              items: {
                query: "page('home').contenu.toStructure",
                select: {
                  type: "structureItem.type",
                  pagelink: {
                    query: "structureItem.pagelink.toPage",
                    select: {
                      title: "page.title",
                      parent: "page.parent.uid",
                      uid: "page.uid"
                    }
                  },
                  width: "structureItem.width",
                  text: "structureItem.text.kirbytext",
                  marquee: "structureItem.marquee",
                  image: {
                    query: "structureItem.image.toFile",
                    select: {
                      url: "file.resize(800).url",
                      thumb: "file.resize(100).url"
                    }
                  },
                video: {
                  query: "structureItem.video.toFile",
                  select: {
                    url: "file.url"
                  }
                }
              }
            }
          }
          },
          {
            auth
          }
        )
        .then(function(response) {
            commit("SET_COLLECTIONS", { uid: payload, data: response.data.result });
        });
    },
    async loadCategories({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('shop').categories.split"
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_CATS", response.data.result);
        });
    },
    async loadRetrait({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('shop').pickuptext"
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_RETRAIT", response.data.result);
        });
    },
    async loadProducts({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('shop').children",
            select: {
              title: true,
              created: "page.created.toDate()",
              uid: true,
              num: true,
              status: "page.status",
              collection: {
                query: "page.collection.toPage",
                select: {
                  title: "page.title",
                  uid: "page.uid",
                  color: "page.color"
                }
              },
              active: "page.active.toBool",
              caption: true,
              category: "page.category.split",
              description: "page.description.kirbytext",
              metadata: "page.metadata.toData('json')",
              items: {
                query: "page.children.listed",
                select: {
                  id: "page.uid",
                  taille: true,
                  price: true,
                  finite: true,
                  weight: true
                }
              },
              extras: {
                query: "page.extra.toStructure",
                select: {
                  title: "structureItem.title",
                  text: "structureItem.text.kirbytext"
                }
              },
              images: {
                query: "page.images.sortBy('sort')",
                select: {
                  thumb: "file.resize(100).url",
                  url: "file.resize(1500).url"
                }
              }
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_ITEMS", response.data.result.data);
        });
    },
    async loadAbout({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('about')",
            select: {
              title: true,
              uid: true,
              tagline: "page.tagline_md",
              email: true,
              content: {
                query: "page.contenu.toStructure",
                select: {
                  title: "structureItem.title",
                  text: "structureItem.text.kirbytext"
                }
              }
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_ABOUT", response.data.result);
        });
    },
    async loadConditions({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('terms-conditions').conditions.toStructure",
            select: {
              title: "structureItem.title",
              text: "structureItem.text.kirbytext"
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_CONDITIONS", response.data.result.data);
        });
    },
    async loadPolicy({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('privacy-policy').conditions.toStructure",
            select: {
              title: "structureItem.title",
              text: "structureItem.text.kirbytext"
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_POLICY", response.data.result.data);
        });
    },
    async loadStockist({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('stockist').conditions.toStructure",
            select: {
              title: "structureItem.title",
              text: "structureItem.text.kirbytext"
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_STOCKIST", response.data.result.data);
        });
    },
    async loadMasque({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('masque')",
            select: {
              left: {
                query: "page.left.toStructure",
                select: {
                  title: "structureItem.title",
                  text: "structureItem.text.kirbytext"
                }
              },
              right: {
                query: "page.right.toStructure",
                select: {
                  title: "structureItem.title",
                  text: "structureItem.text.kirbytext"
                }
              }
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_MASQUE", response.data.result);
        });
    },
    async loadHeadMasque({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('head-masque')",
            select: {
              left: {
                query: "page.left.toStructure",
                select: {
                  title: "structureItem.title",
                  text: "structureItem.text.kirbytext"
                }
              },
              right: {
                query: "page.right.toStructure",
                select: {
                  title: "structureItem.title",
                  text: "structureItem.text.kirbytext"
                }
              }
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_HEAD_MASQUE", response.data.result);
        });
    },
    async loadSizeGuide({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('size-guide').conditions.toStructure",
            select: {
              title: "structureItem.title",
              text: "structureItem.text.kirbytext"
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_SIZEGUIDE", response.data.result.data);
        });
    },
    async loadSuccess({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('success').conditions.toStructure",
            select: {
              title: "structureItem.title",
              text: "structureItem.text.kirbytext"
            }
          },
          {
            auth
          }
        )
        .then(function(response) {
          commit("SET_SUCCESS", response.data.result.data);
        });
    },
  },
  mutations: {
    SET_SITE(state, site) {
      state.site = site;
    },
    SET_HOME(state, home) {
      state.home = home;
    },
    SET_COLLECTIONS(state, data) {
      state[data.uid] = data.data.data;
    },
    SET_ITEMS(state, items) {
      state.items = items;
    },
    SET_CATS(state, categories) {
      state.categories = categories;
    },
    SET_RETRAIT(state, data) {
      state.retrait = data;
    },
    SET_ABOUT(state, about) {
      state.about = about;
    },
    SET_CONDITIONS(state, conditions) {
      state.conditions = conditions;
    },
    SET_POLICY(state, policy) {
      state.policy = policy;
    },
    SET_MASQUE(state, masque) {
      state.masque = masque;
    },
    SET_HEAD_MASQUE(state, masque) {
      state.headmasque = masque;
    },
    SET_STOCKIST(state, stockist) {
      state.stockist = stockist;
    },
    SET_SIZEGUIDE(state, sizeguide) {
      state.sizeguide = sizeguide;
    },
    SET_SUCCESS(state, data) {
      state.success = data;
    },
  }
});
